import React from 'react'; 
import { TextField, Grid, Avatar, MenuItem, Select, Fab, Switch,} from '@material-ui/core';
import Utils from '../providers/Utils';
import LocalStorage from '../providers/LocalStorage';
import PropTypes from 'prop-types';
import Menu from '../commons/Menu'
import Calendar from 'react-calendar';
import ro from 'date-fns/locale/ro';
// import en from 'date-fns/locale/en'

export default class CosturiListProiect extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            strSearchString:'',
            elementeAfisate:[]
            
        } 
    }



    componentDidMount(){
       this.setState({ elementeAfisate:this.props.elemente || []})
    }


    componentWillReceiveProps(nextProps){
        this.setState({
            elementeAfisate:nextProps.elemente || [],
        })
    }

    getLitereAvatar = (tx)=>{

        if(tx !== null){

            return tx.substring(0,1).toUpperCase()
        }
    }

    // filterFunc = (ev) => {

    //     this.setState({strSearchString:ev.target.value})
    //     let e = [...this.props.elemente]

    //     e = e.filter(x=>{
            
    //         if( (x[this.props.onlyColumns.nume]||'').toLowerCase().trim().includes( ev.target.value.toLowerCase() )  )
    //             return true
            
    //         if( (x[this.props.onlyColumns.description]||'').toLowerCase().trim().includes( ev.target.value.toLowerCase() )  )
    //             return true
            
    //         return false

    //     })

    //     this.setState({elementeAfisate: e})
    // }

    render(){
        return (
            <div className='pm-users-list-container'>
                       

                <TextField className='inputFocus' label={this.props.dict.comune.search} onChange={this.filterFunc} value={this.state.strSearchString} />
                <ul style={{cursor:'pointer', position:'relative'}} className='pm-list-container'>
                <li className='pm-list-item-user' >
                                   
                                   <Grid container className='pm-list-container-avatar-head' >
                                   
   
                                       <Grid item xs={5} sm={5} md={5} lg={5} xl={5} style={{justifyContent:'left'}}  className='pm-list-item-avatar-head'>
                                           <span className='pm-list-item-span-head'>{this.props.dict.settings.nume}</span>
                                       </Grid>
                                       
                                       <Grid item xs={3} sm={3} md={3} lg={3} xl={3} style={{justifyContent:'left'}}   className='pm-list-item-avatar-head'>
                                           <span className='pm-list-item-span-head'>{this.props.dict.settings.valoare}</span>
                                       </Grid>
                                       <Grid item xs={3} sm={3} md={3} lg={3} xl={3} style={{justifyContent:'left'}}  className='pm-list-item-avatar-head'>
                                           <span className='pm-list-item-span-head'>{this.props.dict.settings.dataCost}</span>
                                       </Grid>
                                      
                       
                                       
                                      
                                   </Grid>
                                      
                                   </li>
                  
                    {
                        this.state.elementeAfisate.map( (e,idx) =>{
                            return (
                                <li className='pm-list-item-user' key={idx}  >
                                   
                                <Grid container   className='pm-list-container-avatar'>
                                
                                

                                    <Grid    item xs={5} sm={5} md={5} lg={5} xl={5}  className='pm-list-item-avatar'>
                             
                                        <input style={{backgroundColor:'transparent'}}  className='pm-task-time-input' type='text' value={e[this.props.onlyColumns.nume]}  onChange={(ev)=>{this.props.numeChange(e,ev)}} onBlur={()=>{this.props.updateNume(e)}} /> 
                                
                                    </Grid>

                                    
                                    <Grid  item xs={3} sm={3} md={3} lg={3} xl={3}  className='pm-list-item-avatar'>
                                    
                                    <input style={{backgroundColor:'transparent'}}  className='pm-task-time-input' type='number' value={e[this.props.onlyColumns.valoare]}  onChange={(ev)=>{this.props.valoareChange(e,ev)}} onBlur={()=>{this.props.updateValoare(e)}} /> 
                                

                                    </Grid>
                                  
                                    <Grid  item xs={3} sm={3} md={3} lg={3} xl={3}  className='pm-list-item-avatar'>
                                    
                                    <input style={{backgroundColor:'transparent'}}  className='pm-task-time-input' type='date' value={e[this.props.onlyColumns.data_costului]}  onChange={(ev)=>{this.props.dataChange(e,ev)}} onBlur={()=>{this.props.updateData(e)}} /> 
                                

                                    </Grid>
                                    
                                   
                                </Grid>
                                   
                                </li>
                            )
                        })
                    }
                </ul>

            </div>
        );
    }


}// end class


CosturiListProiect.propTypes={
    elemente:PropTypes.array,
    onlyColumns:PropTypes.object,
    dict:PropTypes.object,
    onElClick:PropTypes.func

}